<div [ngClass]="formatter">
  <label class="bl-label bl-font-weight--800 bl-font-size--14" [for]="field.id" [class.bl-required]="field.required">
    {{ field.label }}
    <ng-container *ngIf="field.config.tooltip">
      <button type="button" aria-label="tooltip" class="bl-font-color--blue bl-margin-left--4">
        <i class="cu-info-circle" eaTooltip="{{ field.config.tooltip }}"></i>
      </button>
      <span id="tooltip-info-{{ field.id }}" class="bl-screen-reader-only">{{ field.config.tooltip }}</span>
    </ng-container>
  </label>
  <input
    type="text"
    class="bl-input"
    #input
    [attr.inputmode]="field.inputMode"
    [attr.aria-describedby]="field.id + '-desc-container'"
    [attr.data-automation-id]="field.automationId"
    [cuFieldState]="field"
    [disabled]="!field.enabled"
    [id]="field.id"
    [placeholder]="field.config.placeholder || ''"
    [(ngModel)]="maskedValue"
    (blur)="focused = false; processMask(false)"
    (cut)="processMask()"
    (focus)="focused = true; processMask()"
    (input)="processMask()"
    (keyup)="processMask()"
    (mouseup)="processMask()"
    (paste)="processMask()"
    (selectionchange)="processMask()"
    (keydown.enter)="$event.target['blur']()"
    [hidden]="showObfuscatedValue"
  />
  <input
    type="text"
    class="bl-input"
    [attr.inputmode]="field.inputMode"
    [id]="field.id + '_obfuscate'"
    [hidden]="!showObfuscatedValue"
    [(ngModel)]="obfuscatedValue"
    (keydown)="onMaskFieldKeydown($event)"
  />
  <button type="button" (click)="showUnObfuscatedValue()" class="bl-input-append input-eye-icon" id="reveal-password">
    <i [ngClass]="showObfuscatedValue ? 'cu-eye' : 'cu-eye-slash'"></i>
    <span class="bl-screen-reader-only">
      {{ showObfuscatedValue ? ('ssninput/showssn' | dictionary) : ('ssninput/hidessn' | dictionary) }}
    </span>
  </button>
</div>
